module.exports = __webpack_public_path__ + "24e004ab/img/settings-ico.a214628d.svg";